import { Button } from "antd";
import {
  ArrowLeftOutlined,
  HomeOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import LogoSrc from "../../assets/image/logo.svg";
import "../../style/layout/notfound.scss";

const NotFound = ({ title }) => {
  // set title
  document.title = title;
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-glow not-found-glow-one" />
      <div className="not-found-glow not-found-glow-two" />
      <main className="not-found-card">
        <Link
          className="not-found-brand"
          to="/"
          aria-label="Resume Builder home"
        >
          <img src={LogoSrc} alt="" />
          <span>
            Resume <strong>Builder</strong>
          </span>
        </Link>

        <div className="not-found-visual" aria-hidden="true">
          <span className="not-found-orbit">
            <SearchOutlined />
          </span>
          <div className="not-found-code">
            <span>4</span>
            <i />
            <span>4</span>
          </div>
          <span className="not-found-dot dot-one" />
          <span className="not-found-dot dot-two" />
          <span className="not-found-dot dot-three" />
        </div>

        <div className="not-found-copy">
          <span className="not-found-eyebrow">Page not found</span>
          <h1>This page took a different career path.</h1>
          <p>
            The address may be incorrect, or the page may have moved. Let’s get
            you back to building something great.
          </p>
        </div>

        <div className="not-found-actions">
          <Link to="/">
            <Button type="primary" size="large" icon={<HomeOutlined />}>
              Back to Home
            </Button>
          </Link>
          <Button
            size="large"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          >
            Go back
          </Button>
        </div>
        <p className="not-found-help">
          Error code: 404 · Check the URL and try again
        </p>
      </main>
    </div>
  );
};

export default NotFound;
